import React, { useState, useEffect } from 'react';

const ContentEditor: React.FC = () => {
  const [content, setContent] = useState('');
  const [originalContent, setOriginalContent] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await fetch('/api/content/about', {
        credentials: 'include',
      });
      const data = await response.json();
      const text = data.content || '';
      setContent(text);
      setOriginalContent(text);
    } catch (error) {
      console.error('Error fetching content:', error);
      setError('Failed to load content');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setMessage('');
    setError('');
    setSaving(true);

    try {
      const response = await fetch('/api/content/about', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ content }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage('Content saved successfully!');
        setOriginalContent(content);
      } else {
        setError(data.error || 'Failed to save content');
      }
    } catch (error) {
      setError('Network error. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  const hasChanges = content !== originalContent;

  return (
    <div className="window" style={{ width: '100%', maxWidth: '800px' }}>
      <div className="title-bar">
        <div className="title-bar-text">About Me Text Editor</div>
      </div>
      <div className="window-body" style={{ padding: '16px' }}>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            <p style={{ fontSize: '11px', marginBottom: '12px' }}>
              This text will be displayed in the <strong>about_me.txt</strong> Notepad window on the desktop.
            </p>

            <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              style={{
                width: '100%',
                height: '400px',
                padding: '8px',
                fontFamily: '"Courier New", monospace',
                fontSize: '13px',
                resize: 'vertical',
                border: '2px inset #808080'
              }}
              placeholder="Enter your about me text here..."
            />

            <div style={{ marginTop: '12px', display: 'flex', gap: '8px', alignItems: 'center' }}>
              <button onClick={handleSave} disabled={saving || !hasChanges}>
                {saving ? 'Saving...' : 'Save'}
              </button>
              <button
                onClick={() => setContent(originalContent)}
                disabled={!hasChanges}
              >
                Reset
              </button>
              {hasChanges && (
                <span style={{ fontSize: '11px', color: '#666' }}>
                  * Unsaved changes
                </span>
              )}
            </div>

            {message && (
              <div style={{
                background: '#008000',
                color: '#fff',
                padding: '8px',
                marginTop: '12px',
                fontSize: '11px'
              }}>
                {message}
              </div>
            )}

            {error && (
              <div style={{
                background: '#ff0000',
                color: '#fff',
                padding: '8px',
                marginTop: '12px',
                fontSize: '11px'
              }}>
                {error}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ContentEditor;
